export function tokenColor(name: string): string {
  if (typeof window === 'undefined') return 'transparent';
  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue(`--${name}`)
    .trim();
  return raw ? `oklch(${raw})` : 'transparent';
}